import { ReactKeycloakProvider } from '@react-keycloak/web';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';

import App from './App.js';
import { DensityProvider } from './components/DensityProvider.js';
import { einmalNeuLaden } from './components/SeitenFehler.js';
import { ThemeProvider } from './components/ThemeProvider.js';
import { WidgetDataContext } from './components/widgets/widget-data.js';
import { keycloak, keycloakInitOptions } from './lib/keycloak.js';
import { loadTenant } from './lib/tenant.js';
import { loadWidgetDataApp } from './lib/widget-data-app.js';
import './styles.css';

// HINWEIS: Die ECharts-Themes (`registerCiviportThemes`) werden NICHT hier
// registriert, weil das den ECharts-Vendor-Chunk (~350 KB gzip) in den
// initial Pageload ziehen wuerde. Stattdessen registriert `useChartTheme()`
// bei seinem ersten Aufruf — also nur, wenn tatsaechlich Charts gerendert
// werden (WidgetRenderer, Prompt-Preview).

// Nach einem neuen Build fehlen die Seiten-Dateien der alten Version: einmal neu laden
// statt einer leeren Seite. Klappt das nicht, zeigt SeitenFehler eine Meldung.
window.addEventListener('vite:preloadError', (event) => {
  if (einmalNeuLaden()) event.preventDefault();
});

const rootEl = document.getElementById('root');
if (!rootEl) {
  throw new Error('#root element not found');
}

// ReactKeycloakProvider ausserhalb von StrictMode: StrictMode mountet im Dev-Server doppelt,
// und eine Keycloak-Instanz darf nur einmal initialisiert werden ("can only be initialized once").
// Im Produktions-Build ohne Unterschied.
// Kommune (Name, Farbe, Gebiet) vor dem ersten Rendern laden: kein Flash der Default-Farbe,
// und Karten und Zwilling kennen das Gebiet von Anfang an.
void loadTenant().then(() => {
  ReactDOM.createRoot(rootEl).render(
    <ReactKeycloakProvider
      authClient={keycloak}
      initOptions={keycloakInitOptions}
      LoadingComponent={
        <div className="flex h-screen items-center justify-center bg-background text-muted-foreground">
          Authentifizierung laeuft...
        </div>
      }
    >
      <React.StrictMode>
        <ThemeProvider>
          <DensityProvider>
            <WidgetDataContext.Provider value={loadWidgetDataApp}>
              <BrowserRouter>
                <App />
              </BrowserRouter>
            </WidgetDataContext.Provider>
          </DensityProvider>
        </ThemeProvider>
      </React.StrictMode>
    </ReactKeycloakProvider>,
  );
});
